module.exports = __webpack_public_path__ + "img/box3_img1_dark.407cdcbe.png";